export const copyToClipboard = async (text: string): Promise<void> => {
    try {
        // Prefer the modern async clipboard API when available (requires HTTPS and user gesture in some browsers)
        if (
            typeof navigator !== 'undefined' &&
            navigator.clipboard &&
            typeof navigator.clipboard.writeText === 'function'
        ) {
            await navigator.clipboard.writeText(text);
            return;
        }

        // Fallback for older browsers (including Safari/iOS)
        if (typeof document !== 'undefined') {
            const textarea = document.createElement('textarea');
            textarea.value = text;

            // iOS will show the keyboard if the element is not readonly
            textarea.setAttribute('readonly', '');

            // Prevent scrolling to bottom and keep it visually hidden
            textarea.style.position = 'fixed';
            textarea.style.top = '0';
            textarea.style.left = '0';
            textarea.style.width = '1px';
            textarea.style.height = '1px';
            textarea.style.padding = '0';
            textarea.style.border = 'none';
            textarea.style.outline = 'none';
            textarea.style.boxShadow = 'none';
            textarea.style.background = 'transparent';
            textarea.style.opacity = '0';
            textarea.style.pointerEvents = 'none';

            document.body.appendChild(textarea);

            // Save existing selection to restore it later
            const selection =
                typeof window !== 'undefined' && window.getSelection
                    ? window.getSelection()
                    : null;
            let priorRange: Range | null = null;
            try {
                if (selection && selection.rangeCount > 0) {
                    priorRange = selection.getRangeAt(0);
                }
            } catch (e) {
                priorRange = null;
            }

            // iOS specific selection trick
            const isIOS =
                typeof navigator !== 'undefined' &&
                /ipad|iphone|ipod/i.test(navigator.userAgent);
            try {
                if (isIOS && selection) {
                    const range = document.createRange();
                    range.selectNodeContents(textarea);
                    selection.removeAllRanges();
                    selection.addRange(range);
                    textarea.setSelectionRange(0, textarea.value.length);
                } else {
                    textarea.select();
                    textarea.setSelectionRange(0, textarea.value.length);
                }
            } catch (e) {
                // ignore selection errors
            }

            try {
                document.execCommand('copy');
            } catch (e) {
                // ignore copy failures
            }

            // Restore previous selection
            try {
                if (selection) {
                    selection.removeAllRanges();
                    if (priorRange) selection.addRange(priorRange);
                }
            } catch (e) {
                // ignore
            }

            document.body.removeChild(textarea);
        }
    } catch (e) {
        // Ignore copy failures
    }
};
